import React, { useState, Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Button,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Toolbar
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBack } from '@material-ui/icons';
import TankSettings from './TankSettings';
import TlmSettings from './TlmSettings';
import { Auth } from 'aws-amplify';
import { host } from "../../../data";
import AddTankIcon from "../../Components/AddTankIcon.js"
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  iconButtons: {
    marginRight: theme.spacing(1),
  },
}))

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

const TabsSettings = (props) => {
  const { t, i18n } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [fluids, setFluids] = useState([{ id: 0, name: '' }]);
  const [tankData, setTankData] = useState({});
  const [dataReady, setDataReady] = useState(0);
  const [devices, setDevices] = useState([]);
  const [pulseDevices, setPulseDevices] = useState([]);
  const [orgTags, setOrgTags] = useState([]);
  let history = useHistory();

  const updateDevices = (data) => {
    var i = 0;
    var lPulseDevices = [];
    var lDevices = [];
    for (i = 0; i < data.deviceList.length; i++) {
      if (data.deviceList[i].type === "PulseHUB") {
        lPulseDevices.push(data.deviceList[i]);
      }
      else {
        lDevices.push(data.deviceList[i]);
      }
    }

    setDevices(lDevices);
    setPulseDevices(lPulseDevices);
  };

  React.useEffect(() => {
    Auth.currentAuthenticatedUser()
      .then(data => {
        const sessionToken = data.signInUserSession.idToken.jwtToken;
        const tankId = props.tankId;

        var requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': sessionToken
          }
        };

        if (null === tankId) {
          fetch(host + '/orgs/' + props.orgInfo.orgId + '/availabledevices', requestOptions)
            .then(results => results.json())
            .then(data => {
              var Data = [];
              var i;

              if (data.error = "OK") {
                for (i = 0; i < data.fluidsList.length; i++) {
                  Data[i] = { id: i, name: data.fluidsList[i].name };
                }

                var lPulseDevices = [];
                var lDevices = [];

                for (i = 0; i < data.deviceList.length; i++) {
                  if (data.deviceList[i].type === "PulseHUB") {
                    lPulseDevices.push(data.deviceList[i]);
                  }
                  else {
                    lDevices.push(data.deviceList[i]);
                  }
                }

                setFluids(Data);
                setDevices(lDevices);
                setPulseDevices(lPulseDevices);
                setOrgTags(data.orgTags);
              }
              else {
                alert(data.error);
              }
            }).catch((error) => {
            });
          setDataReady(1);
        }

        if (null !== tankId) {
          fetch(host + '/orgs/' + props.orgInfo.orgId + '/branches/' + props.branchInfo.branchId + '/sites/' + props.siteId + '/tanks/' + tankId + '/availabledevices', requestOptions)
            .then(results => results.json())
            .then(data => {
              var Data = [];
              var lPulseDevices = [];
              var lDevices = [];
              var i;

              if (data.error = "OK") {
                for (i = 0; i < data.fluidsList.length; i++) {
                  Data[i] = { id: i, name: data.fluidsList[i].name };
                }

                for (i = 0; i < data.deviceList.length; i++) {
                  if (data.deviceList[i].type === "PulseHUB") {
                    lPulseDevices.push(data.deviceList[i]);
                  }
                  else {
                    lDevices.push(data.deviceList[i]);
                  }
                }

                setFluids(Data);
                setDevices(lDevices);
                setPulseDevices(lPulseDevices);
                setOrgTags(data.orgTags);
              }
              else {
                alert(data.error);
              }
            }).catch((error) => {
            });

          console.log("fetch tank info")

          fetch(host + '/orgs/' + props.orgInfo.orgId + '/branches/' + props.branchInfo.branchId + '/sites/' + props.siteId + '/tanks/' + tankId, requestOptions)
            .then(results => results.json())
            .then(data => {
              var clientTimeZoneOffset = new Date().getTimezoneOffset() / 60;
              var Data = data;

              if (Data.MeasurementTime_1 && Data.MeasurementTime_1 !== "NONE") {
                Data.MeasurementTime_1 = (parseInt(Data.MeasurementTime_1) - clientTimeZoneOffset);
                if (Data.MeasurementTime_1 > 23) {
                  Data.MeasurementTime_1 = Data.MeasurementTime_1 - 24;
                }
                if (Data.MeasurementTime_1 < 0) {
                  Data.MeasurementTime_1 = Data.MeasurementTime_1 + 24;
                }
                Data.MeasurementTime_1 = Data.MeasurementTime_1.toString()
              }
              if (Data.MeasurementTime_2 && Data.MeasurementTime_2 !== "NONE") {
                Data.MeasurementTime_2 = (parseInt(Data.MeasurementTime_2) - clientTimeZoneOffset);
                if (Data.MeasurementTime_2 > 23) {
                  Data.MeasurementTime_2 = Data.MeasurementTime_2 - 24;
                }
                if (Data.MeasurementTime_2 < 0) {
                  Data.MeasurementTime_2 = Data.MeasurementTime_2 + 24;
                }
                Data.MeasurementTime_2 = Data.MeasurementTime_2.toString()
              }
              if (!Data.serial) {
                setValue(1);
              }

              setTankData(Data);
              setDataReady(1);
            }).catch((error) => {
              console.log(error)
            });
        }
      });
  }, [props.tankId]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dimensionUnits = [{ key: 'inches', label: t("inches") },
  { key: 'feet', label: t("feet") },
  { key: 'centimeters', label: t("centimeters") }];
  const volumeUnits = [{ key: 'liters', label: t("liters") }, { key: 'gallons', label: t("gallons") }];
  const tankShape = [
    { key: 'vertical', label: t("verticalCylinderRect") },
    { key: 'horizontal', label: t("horizontalCynlinder") },
    { key: 'obround', label: t("obround") },
    { key: 'table', label: t("strappingTable") },
    { key: 'pulseHUB', label: t("existingPulseProTank") }
  ];

  const handleNewTankClick = () => {
    props.setPageDataReady(0);
    setDataReady(0);
    props.setTankId(null);
  }

  const addFluid = async (fluid) => {
    setFluids(() => {
      return [
        ...fluids, fluid
      ]
    });
  };

  const handleExit = () => {
    let url = { pathname: ('/orgs/').concat(props.orgInfo.orgName).concat('/branches/').concat(props.branchInfo.branchName).concat('/sites/').concat(props.site) };

    if (null !== props.tankId) {
      url = { pathname: ('/orgs/').concat(props.orgInfo.orgName).concat('/branches/').concat(props.branchInfo.branchName).concat('/sites/').concat(props.site).concat('/tanks/').concat(props.tankName) };
    }

    history.push(url);
  };

  if (!dataReady) {
    return (<div />);
  }

  return (
    <Fragment>
      {(null !== props.tankId) && <Toolbar>
        <Tooltip title={t("goBackToTankView")}>
          <IconButton color='primary' onClick={handleExit}>
            <ArrowBack />
          </IconButton>
        </Tooltip>

        <Button onClick={handleExit} color="primary">
          {t("goBackToTankView")}
        </Button>

        <div className={classes.grow} />
        <Tooltip title={t("newTank")}>
          <IconButton color='inherit'
            component={RouterLink}
            className={classes.iconButtons}
            onClick={handleNewTankClick}
            to={props.baseUrl.concat('/new')}>
            <AddTankIcon />
          </IconButton>
        </Tooltip>
      </Toolbar>}

      <Tabs value={value}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}>
        <Tab label={t("tank")} />
        {(null !== props.tankId) && <Tab label={t("tlm")} />}
      </Tabs>

      <TabPanel value={value} index={0}>
        <TankSettings
          orgInfo={props.orgInfo}
          branchInfo={props.branchInfo}
          site={props.site}
          siteId={props.siteId}
          tankId={props.tankId}
          handleExit={handleExit}
          tank={tankData}
          setTankData={setTankData}
          fluids={fluids}
          dimensionunits={dimensionUnits}
          volumeunits={volumeUnits}
          tank-shape={tankShape}
          orgTags={orgTags}
          setPageDataReady={props.setPageDataReady}
          setTabsDataReady={setDataReady}
          addfluid={(fluid) => {
            addFluid(fluid)
          }} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <TlmSettings
          orgInfo={props.orgInfo}
          branchInfo={props.branchInfo}
          site={props.site}
          siteId={props.siteId}
          tankId={props.tankId}
          handleExit={handleExit}
          tlm={tankData}
          setTankData={setTankData}
          devices={devices}
          pulseDevices={pulseDevices}
          updateDevices={updateDevices}
        />
      </TabPanel>
    </Fragment>
  );
};

export default TabsSettings;
